import { Translate } from '@dreryk/react-common';

import { FormSectionHeader } from '../../../../common/FormSectionHeader';
import { PatientEntitlementsTable } from '../../../../patientEntitlements/table/PatientEntitlementsTable';
import { patientEntitlementsTranslationKeys } from '../../../../translations';

type AdditionalEntitlementsFormSectionProps = {
   readonly patientId: number;
};

export const AdditionalEntitlementsFormSection = (props: AdditionalEntitlementsFormSectionProps): JSX.Element => {
   return (
      <div>
         <FormSectionHeader>
            <Translate>{patientEntitlementsTranslationKeys.additionalEntitlements}</Translate>
         </FormSectionHeader>
         <PatientEntitlementsTable patientId={props.patientId} />
      </div>
   );
};
